import type { ReactNode } from 'react';
import styles from './index.module.scss';

export interface FaqItemProps {
  question: string;
  open: boolean;
  onToggle: () => void;
  children?: ReactNode;
  last?: boolean;
}

export default function FaqItem({ question, open, onToggle, children, last }: FaqItemProps) {
  const itemClass = `${styles.item} ${last ? styles.last : ''}`;
  const iconClass = `${styles.icon} ${open ? styles.iconOpen : ''}`;

  return (
    <div className={itemClass}>
      <button className={styles.header} onClick={onToggle} aria-expanded={open}>
        <span className={styles.question}>{question}</span>
        <span className={iconClass} aria-hidden />
      </button>
      {open && (
        <div className={styles.body}>
          {children && <div className={styles.answer}>{children}</div>}
        </div>
      )}
    </div>
  );
}
